import { ref } from '@vue/composition-api';

/** 是否展示半屏“印花卡” */
const isShowHalfTask = ref(false);

export const useHalfTask = () => {
  /** 展示“印花卡” */
  const showHalfTask = () => {
    isShowHalfTask.value = true;
  };
  /** 隐藏“印花卡” */
  const hideHalfTask = () => {
    isShowHalfTask.value = false;
  };

  return {
    isShowHalfTask,

    showHalfTask,
    hideHalfTask,
  };
};
